import { Box } from '@metropolis-io/components';
import { TabContentRenderer } from './TabContentRenderer';
import type {
  RenderTabLabelParams,
  RenderTabBarParams,
  RenderTabContentParams,
} from './Tabs.types';

export const defaultLabelRender = ({
  tabData: { id, label },
  Component,
  props,
  context,
}: RenderTabLabelParams) => (
  <Component
    key={id}
    tabId={id}
    label={label}
    active={id === context.activeTabId}
    onClick={() => {
      context.setActiveTab(id);
    }}
    {...props}
  />
);

export const defaultTabBarRender = ({
  tabNodes,
  props,
}: RenderTabBarParams) => (
  <Box
    flexDirection="row"
    {...props}
  >
    {tabNodes}
  </Box>
);

export const defaultTabContentRender = ({
  props,
  context,
}: RenderTabContentParams) => (
  <TabContentRenderer
    {...props}
    {...context}
  />
);
